import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { Loader2, PhoneOff } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

// Opened on the phone from the desktop QR code; the user is already signed in by ProtectedRoute.
export default function CallHandoff() {
  const { token } = useParams();
  const { token: auth } = useAuth();
  const nav = useNavigate();
  const [err, setErr] = useState('');
  useEffect(() => {
    axios.get(`${API}/api/calling/handoff/${token}`, { headers: { Authorization: `Bearer ${auth}` } })
      .then((r) => nav(`/calling?session=${r.data.session_id}`, { replace: true }))
      .catch((e) => setErr(e.response?.data?.detail || 'This phone link could not be opened'));
  }, [token, auth, nav]);
  return (
    <div className="grid min-h-screen place-items-center bg-[#F6F7FB] px-6 text-center" data-testid="call-handoff-page">
      {err ? (
        <div data-testid="call-handoff-error">
          <PhoneOff className="mx-auto h-10 w-10 text-rose-500" />
          <p className="mt-3 text-lg font-bold text-[#0A1124]">{err}</p>
          <button type="button" onClick={() => nav('/calling')} data-testid="call-handoff-open-calling" className="mt-5 rounded-full bg-[#15133A] px-5 py-2.5 text-sm font-semibold text-white">Open calling queue</button>
        </div>
      ) : <p className="flex items-center gap-2 text-sm text-slate-500"><Loader2 className="h-4 w-4 animate-spin" />Opening your calling queue…</p>}
    </div>
  );
}
